import { FORM_FIELDS } from '../../constants/form.js';
import '../../constants/sources.js';
import { getValidationSchema } from '../../helpers/validators.js';

var schema = function (options) {
    return getValidationSchema([FORM_FIELDS.PERIOD, FORM_FIELDS.AMOUNT, FORM_FIELDS.PURPOSE], options);
};

export { schema };
//# sourceMappingURL=schema.js.map
